import React from 'react';
import PropTypes from 'prop-types';

import { P } from '@decisiv/ui-components/lib/components/Typography';

export default function TextCell({ text }) {
  const value = text || '–';

  return <P>{value}</P>;
}

TextCell.propTypes = {
  text: PropTypes.string,
};

TextCell.defaultProps = {
  text: undefined,
};
